"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertifierComponent = exports.certifierLinkTestId = exports.certifierTestId = void 0;
var React = require("react");
var Style_1 = require("../common/Style");
var Id_1 = require("../common/Id");
var Localize_1 = require("../../gen-src/Localize");
var userStyle = {
    color: Style_1.discreteDarkColor
};
/**
 * Test id attribute value (prefix) for certifier component.
 */
exports.certifierTestId = 'certifier';
exports.certifierLinkTestId = 'certifier-link';
/**
 * Certifier component.
 * @param props - The props for this certifier. Note that props are intersected with HTML props so that the styling can changed for
 * different use cases.
 */
function CertifierComponent(props) {
    var user;
    if (!props.linksDisabled && props.url) {
        user = (React.createElement("a", { "data-tb-test-id": (0, Id_1.generateId)(exports.certifierLinkTestId, props.id), style: userStyle, href: props.url, target: props.newTab ? '_blank' : undefined }, props.displayName));
    }
    else {
        user = React.createElement("span", { style: (props.customUserStyle) ? props.customUserStyle : undefined }, props.displayName);
    }
    return (React.createElement("span", { "data-tb-test-id": (0, Id_1.generateId)(exports.certifierTestId, props.id), className: props.className, style: props.style },
        Localize_1.Messages.CertifiedBy(),
        " ",
        user));
}
exports.CertifierComponent = CertifierComponent;
//# sourceMappingURL=Certifier.js.map